import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import LinearProgress from '@mui/material/LinearProgress';
import Tooltip from '@mui/material/Tooltip';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { calculateFinMapleScore } from '../../utils/finmapleScore';

const PILLARS = [
  { key: 'costos', label: 'Costos reales', emoji: '\uD83D\uDCB0', tooltip: 'Evalua cuota anual, tasas y penalidades' },
  { key: 'newcomer', label: 'Para recien llegados', emoji: '\uD83C\uDF41', tooltip: 'Puedes obtenerla sin historial crediticio canadiense?' },
  { key: 'digital', label: 'Experiencia digital', emoji: '\uD83D\uDCF1', tooltip: 'Calidad del app, banca online y soporte digital' },
  { key: 'beneficios', label: 'Beneficios reales', emoji: '\uD83C\uDF81', tooltip: 'Cash back, puntos, millas u otras recompensas' },
  { key: 'espanol', label: 'Soporte en espanol', emoji: '\uD83D\uDDE3\uFE0F', tooltip: 'El banco ofrece atencion y materiales en espanol?' },
];

const barColor = (val) => (val >= 4.0 ? '#2E7D32' : val >= 3.0 ? '#F9A825' : '#C62828');

const FinMapleScoreDetail = ({ card }) => {
  const { total, breakdown } = calculateFinMapleScore(card);

  return (
    <Box
      sx={{
        bgcolor: '#F7F9FC',
        borderRadius: '12px',
        p: 2,
        border: '1px solid #E6E9EE',
      }}
    >
      {/* Header */}
      <Box sx={{ display: 'flex', alignItems: 'baseline', justifyContent: 'space-between', mb: 1.5 }}>
        <Typography variant="subtitle2" sx={{ fontWeight: 700, color: '#1E3A5F' }}>
          FinMaple Score&trade;
        </Typography>
        <Typography variant="h6" sx={{ fontWeight: 700, fontFeatureSettings: "'tnum'", color: barColor(total) }}>
          {total.toFixed(1)}<Typography component="span" variant="body2" sx={{ color: '#5F6B7A' }}> / 5</Typography>
        </Typography>
      </Box>

      {/* Overall bar */}
      <LinearProgress
        variant="determinate"
        value={(total / 5) * 100}
        sx={{
          height: 8,
          borderRadius: 4,
          mb: 2,
          bgcolor: 'rgba(0,0,0,0.06)',
          '& .MuiLinearProgress-bar': { bgcolor: barColor(total), borderRadius: 4 },
        }}
      />

      {/* Pillar rows */}
      {PILLARS.map(({ key, label, emoji, tooltip }) => {
        const val = breakdown[key];
        return (
          <Box key={key} sx={{ mb: 1 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                <Typography variant="caption" sx={{ fontSize: '0.85rem' }}>{emoji}</Typography>
                <Typography variant="caption" sx={{ color: '#5F6B7A', fontSize: '0.75rem' }}>
                  {label}
                </Typography>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.3 }}>
                <Typography variant="caption" sx={{ fontWeight: 700, fontFeatureSettings: "'tnum'", color: barColor(val), fontSize: '0.75rem' }}>
                  {val.toFixed(1)}
                </Typography>
                <Tooltip title={tooltip} arrow placement="top">
                  <InfoOutlinedIcon sx={{ fontSize: '0.8125rem', color: '#5F6B7A', cursor: 'help' }} />
                </Tooltip>
              </Box>
            </Box>
            <LinearProgress
              variant="determinate"
              value={(val / 5) * 100}
              sx={{
                height: 5,
                borderRadius: 4,
                bgcolor: 'rgba(0,0,0,0.06)',
                '& .MuiLinearProgress-bar': { bgcolor: barColor(val), borderRadius: 4 },
              }}
            />
          </Box>
        );
      })}

      {/* Footer */}
      <Typography variant="caption" sx={{ color: '#5F6B7A', fontSize: '0.75rem', mt: 1, display: 'block' }}>
        FinMaple Score&trade; es una evaluacion editorial independiente
      </Typography>
    </Box>
  );
};

export default FinMapleScoreDetail;
